import { combineReducers } from 'redux';
import Playback, { IPlaybackState } from './playback';
import UI, { IUIState } from './ui';
import Marker, { IMarkerState } from './marker';
import Resolution, { IResolutionState } from './resolution';
import Subtitles, { ISubtitlesState } from './subtitles';
import Autoplay, { IAutoplayState } from './autoplay';
import ContextMenu, { IContextMenuState } from './contextMenu';
import PlayerError, { IPlayerErrorState } from './playerError';
import Csat, { ICsatState } from './csat';

export interface IRootState {
  Playback: IPlaybackState;
  UI: IUIState;
  Marker: IMarkerState;
  Resolution: IResolutionState;
  Subtitles: ISubtitlesState;
  Autoplay: IAutoplayState;
  ContextMenu: IContextMenuState;
  PlayerError: IPlayerErrorState;
  Csat: ICsatState;
}

const appReducer = combineReducers({
  Playback,
  UI,
  Marker,
  Resolution,
  Subtitles,
  Autoplay,
  ContextMenu,
  PlayerError,
  Csat,
});

export const RESET_STATE_ACTION_TYPE = 'RESET_STATE';

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE_ACTION_TYPE) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
